<template>
  <div>
    <!--Settings change Warning-->
    <v-alert
      border="start"
      border-color="accentOrange"
      class="text-primary"
      color="white"
      elevation="1"
      v-if="isVAVDirty"
    >
      <strong class="text-h6">Notice</strong><br />
      You've changed the setting
      <v-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th
                class="text-primary text-subtitle-2 text-left font-weight-bold"
              >
                Setting:
              </th>
              <th
                class="text-primary text-subtitle-2 text-left font-weight-bold"
              >
                Current Value:
              </th>
              <th
                class="text-primary text-subtitle-2 text-left font-weight-bold"
              >
                New Value:
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="setting in getVAVNewSettings()" :key="setting.name">
              <td class="text-primary text-subtitle-2 text-left">
                {{ setting.name }}
              </td>
              <td class="text-primary text-subtitle-2 text-right">
                {{ setting.currentSetting }}
              </td>
              <td class="text-primary text-subtitle-2 text-right">
                {{ setting.newSetting }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-table>
    </v-alert>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isVAVDirty: boolean;
  getVAVNewSettings: () => {
    name: string;
    currentSetting: string;
    newSetting: string;
  }[];
}>();
</script>

<style lang="scss" scoped>
.v-alert :deep(.v-alert__border) {
  opacity: 1 !important;
}
</style>
